import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import type { BoxProps } from '../box/box';

import * as styles from './input-field.css';

export interface GetInputFieldStylesOptions {
  hasAdjacentSibling?: boolean;
  disabled: boolean;
  error?: boolean;
}

export const getInputFieldStyles = ({
  disabled,
  error = false,
}: GetInputFieldStylesOptions) => ({
  /** for resetting browser defaults on inputs */
  inputResetStyles: styles.inputResetStyles,
  stateStyles: classFilter([
    error && styles.error,
    !disabled && styles.enabled,
  ]),
  boxProps: {
    rounded: true,
    background: 'neutral000',
    color: disabled ? 'neutral250' : 'neutral500',
    border: error ? 'alert500' : 'neutral250',
  } satisfies Partial<BoxProps>,
});
